module.exports = __webpack_public_path__ + "Roboto-BoldItalic.c2e0f75da3677f645034.svg";


//////////////////
// WEBPACK FOOTER
// /app/~/roboto-fontface/fonts/Roboto/Roboto-BoldItalic.svg
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-BoldItalic.svg
// module chunks = 16